<template>
  <OnlineApplications />
</template>

<script>
import OnlineApplications from '@/components/MessageComponents/OnlineApplications.vue';

export default {
  name: 'online-applications-view',
  components: {
    OnlineApplications
  }
  ,
  created(){
    this.$store.commit("EXPIRE_LOGIN");
    if(this.$store.state.user === ''){
      this.$router.push('/');
    }
  }
}
</script>

<style>

</style>